module.exports = __webpack_public_path__ + "static/media/filexfer_130.44cf3365.ico";